import { AutoDisburse, ManualDisburse } from "../../../components";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';

const TAB_STYLE = ({ selected }) =>
    `shrink-0 px-6 py-3.5 text-sm font-medium border-b-2 -mb-px transition-colors focus:outline-none whitespace-nowrap ${
        selected
            ? 'border-[#1e3a6e] text-[#1e3a6e]'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
    }`;

function Disburse({ loan }) {
    return (
        <TabGroup>
            <TabList className="flex border-b border-gray-200 bg-white rounded-t-xl">
                <Tab className={TAB_STYLE}>Manual Disbursement</Tab>
                <Tab className={TAB_STYLE}>Auto Disbursement (MTN)</Tab>
            </TabList>

            <TabPanels className="mt-0">
                <TabPanel><ManualDisburse loan={loan} /></TabPanel>
                <TabPanel><AutoDisburse loan={loan} /></TabPanel>
            </TabPanels>
        </TabGroup>
    );
}

export default Disburse;
